import { css } from 'emotion';

export namespace styles {
  export const container = css({
    // display: 'flex',
    // flexWrap: 'wrap',
    // width: 'auto',
    [`@media(min-width: 678px)`]: {
      width: 310
    }
  });

  export const colorContainer = css({
    margin: 8
  });

  export const color = (hexString: string, selected: boolean, isWhite = false) =>
    css({
      backgroundColor: `#${hexString.substring(0, 6)}`,
      height: 48,
      width: 48,
      borderRadius: '50%',
      border: selected ? '4px solid' : isWhite ? '4px solid #f8f8f8' : undefined
    });
}
